export const separarValorUnidad = (valor = '', idMetaDatoTipo) => {
  const valorString = String(valor ?? '').trim()

  if (idMetaDatoTipo === 'number_unit' || idMetaDatoTipo === 'number') {
    const match = valorString.match(/^-?\d+(?:[.,]\d+)?/)

    const valorBase = match ? match[0] : ''

    return {
      valorBase,
      unidad:
        idMetaDatoTipo === 'number_unit' ? valorString.slice(valorBase.length).trim() : ''
    }
  }

  return { valorBase: valor, unidad: '' }
}
